import { render, staticRenderFns } from "./logoutIcon.vue?vue&type=template&id=3b1f748b&"
import script from "./logoutIcon.vue?vue&type=script&lang=js&"
export * from "./logoutIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports